import React from 'react'
import { Player } from 'video-react'
import 'video-react/dist/video-react.css'
import { Modal } from 'antd'
import styles from './video.module.scss'
import {ArrowLeftOutlined} from "@ant-design/icons";

/**
 * video-react 配置文档：https://video-react.js.org/components/player/
 */
export default class Video extends React.PureComponent {
  ref = React.createRef()

  handleClose = () => {
    this.props.onClose && this.props.onClose()
  }

  componentDidUpdate(prevProps) {
    const { videoShow, videoSrc } = this.props
    const prevSrc = prevProps.videoSrc

    if (!videoShow) {
      this.ref.current.pause()
    } else if (prevSrc !== videoSrc) {
      this.ref.current.load()
    } else {
      this.ref.current.play()
    }
  }

  render() {
    const { videoShow, videoSrc, language } = this.props

    return (
        <Modal
          id="videoModal"
          visible={videoShow}
          className={styles.videomodal}
          footer={null}
          onCancel={this.handleClose}
          closable={false}
          maskStyle={{
            background: 'none',
          }}
        >
          {/* 关闭按钮 */}
          <div className={styles.videoClose} onClick={this.handleClose}>
            <ArrowLeftOutlined style={{fontSize: '7px'}}/>
            {'en'===language &&
            <>
              &nbsp;&nbsp;BACK
            </>
            }
            {'ch'===language &&
            <>
              &nbsp;&nbsp;返回
            </>
            }
          </div>

          {/* 播放器本体 */}
          <Player ref={this.ref} autoPlay>
            <source src={videoSrc} />
          </Player>
        </Modal>
    )
  }
}
